// extracted by mini-css-extract-plugin
export default {"button":"_2IGfA","icon":"_2YFJI","facebook":"_3BR30","twitter":"_I-DI","link":"_18krQ","share":"QrZ8g"};